import { ENGINE_STATUS } from '@modules/controladoria-v2/constants/Status'

const DONE_STATUSES = new Set([ENGINE_STATUS.SUCESSO, ENGINE_STATUS.AVISOS])

/**
 * Returns true iff every relevant engine has a "completed" status (sucesso or avisos).
 * A `nunca | pendente | rodando | erro` status — or a missing engine — returns false.
 *
 * `accessibleEngineIds` (optional) restricts the check to the engines the office
 * actually has access to (per feature flags). Engines outside this list are
 * ignored, so an office that only runs e.g. DRE Geral + DFC isn't blocked from
 * closing the version by the disabled (never-run) Profissional/Produto engines.
 * When omitted, every engine present in `engineStatus` is required (legacy behaviour).
 *
 * Used by both the `allEnginesDone` Vuex getter and by the Phase-3 MonthHeader's
 * "Fechar versão" disabled-rule.
 */
export const allEnginesDone = (engineStatus, accessibleEngineIds = null) => {
  if (!engineStatus || typeof engineStatus !== 'object') return false
  let keys = Object.keys(engineStatus)
  if (Array.isArray(accessibleEngineIds)) {
    const allowed = new Set(accessibleEngineIds)
    keys = keys.filter((key) => allowed.has(key))
  }
  if (keys.length === 0) return false
  for (const key of keys) {
    const entry = engineStatus[key]
    if (!entry || !DONE_STATUSES.has(entry.status)) return false
  }
  return true
}

export default allEnginesDone
